"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateService = void 0;
class CertificateService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    postApiV1Certificate({ moduleId, requestBody, authorization = 'Bearer <token>', locale, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/Certificate/{moduleId}',
            path: {
                moduleId: moduleId,
            },
            headers: {
                Authorization: authorization,
            },
            query: {
                locale: locale,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
            responseType: 'arraybuffer',
        });
    }
}
exports.CertificateService = CertificateService;
